import { maxLength, required } from '../../utils/validation';

export const CategoryValidations = {
  category: [
    required('models.category.name'),
    maxLength(24, 'models.category.name')
  ]
};

class Serializer {
  normalize = data => {
    return {
      id: data.id,
      name: data.value
    };
  };
  serialize = category => {
    return {
      configValue: category.name,
      properties: {
        siteId: category.site
      }
    };
  };
  editSerialize = category => {
    return {
      name: category.name
    };
  };
  deleteSerialize = category => {
    return category.categoryReplacement;
  };
}

export const CategorySerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/category/index.js